import React from "react"

import { Badge } from "@coval/ui/badge"
import { Tooltip } from "@coval/ui/tooltip"

export type VersionChangeType = "save" | "revert"

const CHANGE_TYPE_COPY: Record<
  VersionChangeType,
  { label: string; description: string }
> = {
  save: {
    label: "Saved",
    description: "Created by saving an edit.",
  },
  revert: {
    label: "Reverted",
    description: "Created by reverting to an earlier version.",
  },
}

/**
 * Saved/Reverted label for a version-history row, describing how the version
 * was created. A revert version is highlighted (info) to distinguish "rolled
 * back to an older state" from a normal save. The description is shown on
 * hover and also rendered as screen-reader text, so it joins the accessible
 * name of the row button that contains the badge.
 */
export const ChangeTypeBadge: React.FC<{ changeType: VersionChangeType }> = ({
  changeType,
}) => {
  const { label, description } = CHANGE_TYPE_COPY[changeType]
  return (
    <>
      <Tooltip content={description}>
        <Badge
          variant={changeType === "revert" ? "info" : "default"}
          size="status"
        >
          {label}
        </Badge>
      </Tooltip>
      <span className="sr-only"> {description}</span>
    </>
  )
}
